
  import {Component, Vue} from 'vue-property-decorator';
  import PaidDownloadButtons from "@/components/PaidDownloadButtons.vue";
  import Header from "@/components/Header.vue";
  import LandingSection from "@/components/LandingSection.vue";
  import {gaSendPageview} from "@/components/Analytics";

  @Component({
    components: {PaidDownloadButtons, LandingSection, Header}
  })
  export default class DownloadUpgrade extends Vue {
    private releaseNotesUrl = "https://github.com/bardsoftware/ganttproject/releases/tag/ganttproject-3.3.3309";

    public mounted() {
      gaSendPageview();
    }
  }
